<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">{{ title }}</h1>
    <button
      type="button"
      class="btn-close pull-right"
      aria-label="Close"
      (click)="onConfirm()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body">
    @if (DATA_DISCREPANCY) {
    <section>
      <p>
        Please verify the information you entered for Name and Date of Birth and
        SSN and correct any errors.
      </p>
    </section>
    } @if (CITIZENSHIP_DISCREPANCY) {
    <section>
      <p>
        <strong>Citizenship Status:</strong>
        Our records indicate that <strong>{{ individualName }}</strong> is not a
        US Citizen.
      </p>
      <p>
        Your answer to the question, <strong>"Are you a Citizen?"</strong> has
        been changed to <strong>"No"</strong>.
      </p>
    </section>
    } @if (DEATH_CONFIRMATION) {
    <section>
      <p>
        Our records indicate that <strong>{{ individualName }}</strong> has
        passed away.
      </p>
      <form id="death-confirmation" [formGroup]="deathForm">
        <nh-field label="Has {{ individualName }} passed away?">
          <select
            nh
            name="answer"
            [items]="TAYN"
            formControlName="passedAway"
          ></select>
        </nh-field>
        @if (deathForm.get('deathDate').enabled) {
        <nh-field label="When did {{ individualName }} pass away?">
          <nh-datepicker>
            <input
              type="text"
              name="deathDate"
              class="form-control"
              formControlName="deathDate"
              bsDatepicker
              nh
            />
          </nh-datepicker>
        </nh-field>
        }
      </form>
    </section>
    }
  </div>

  <div class="modal-footer d-block">
    <div class="row g-3 justify-content-end">
      <div class="col-md-3 order-md-2">
        <button
          type="button"
          id="dialog"
          class="btn d-grid btn-primary"
          (click)="onConfirm()"
          [disabled]="deathForm.invalid"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</div>